import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _25702d7e = () => interopDefault(import('../../../pages/404/index.vue' /* webpackChunkName: "pages/404/index" */))
const _6d990fda = () => interopDefault(import('../../../pages/build-your-pack.vue' /* webpackChunkName: "pages/build-your-pack" */))
const _484494f6 = () => interopDefault(import('../../../pages/account/index.vue' /* webpackChunkName: "pages/account/index" */))
const _4c30a4f2 = () => interopDefault(import('../../../pages/password-reset.vue' /* webpackChunkName: "pages/password-reset" */))
const _44b8a598 = () => interopDefault(import('../../../pages/shipping-and-returns.vue' /* webpackChunkName: "pages/shipping-and-returns" */))
const _0547af50 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _b14c32e6 = () => interopDefault(import('../../../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _78abd216 = () => interopDefault(import('../../../pages/account/logout.vue' /* webpackChunkName: "pages/account/logout" */))
const _6bf45dd1 = () => interopDefault(import('../../../pages/account/account.vue' /* webpackChunkName: "pages/account/account" */))
const _2ebd308e = () => interopDefault(import('../../../pages/account/order-history.vue' /* webpackChunkName: "pages/account/order-history" */))
const _59fa0d29 = () => interopDefault(import('../../../pages/account/subscription.vue' /* webpackChunkName: "pages/account/subscription" */))
const _7c76b38a = () => interopDefault(import('../../../pages/_path.vue' /* webpackChunkName: "pages/_path" */))
const _778d938c = () => interopDefault(import('../../../pages/_parent_path/_path.vue' /* webpackChunkName: "pages/_parent_path/_path" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _25702d7e,
    name: "404___en"
  }, {
    path: "/build-your-pack",
    component: _6d990fda,
    name: "build-your-pack___en"
  }, {
    path: "/my-account",
    component: _484494f6,
    name: "account___en"
  }, {
    path: "/password-reset",
    component: _4c30a4f2,
    name: "password-reset___en"
  }, {
    path: "/shipping-and-returns",
    component: _44b8a598,
    name: "shipping-and-returns___en"
  }, {
    path: "/sv",
    component: _0547af50,
    name: "index___sv"
  }, {
    path: "/terms-and-conditions",
    component: _b14c32e6,
    name: "terms___en"
  }, {
    path: "/account/logout",
    component: _78abd216,
    name: "account-logout___en"
  }, {
    path: "/my-account/account",
    component: _6bf45dd1,
    name: "account-account___en"
  }, {
    path: "/my-account/order-history",
    component: _2ebd308e,
    name: "account-order-history___en"
  }, {
    path: "/my-account/subscription",
    component: _59fa0d29,
    name: "account-subscription___en"
  }, {
    path: "/sv/404",
    component: _25702d7e,
    name: "404___sv"
  }, {
    path: "/sv/allmanna-villkor",
    component: _b14c32e6,
    name: "terms___sv"
  }, {
    path: "/sv/build-your-pack",
    component: _6d990fda,
    name: "build-your-pack___sv"
  }, {
    path: "/sv/leveranser-och-returer",
    component: _44b8a598,
    name: "shipping-and-returns___sv"
  }, {
    path: "/sv/mitt-konto",
    component: _484494f6,
    name: "account___sv"
  }, {
    path: "/sv/password-reset",
    component: _4c30a4f2,
    name: "password-reset___sv"
  }, {
    path: "/sv/account/logout",
    component: _78abd216,
    name: "account-logout___sv"
  }, {
    path: "/sv/mitt-konto/konto",
    component: _6bf45dd1,
    name: "account-account___sv"
  }, {
    path: "/sv/mitt-konto/order-historik",
    component: _2ebd308e,
    name: "account-order-history___sv"
  }, {
    path: "/sv/mitt-konto/prenumeration",
    component: _59fa0d29,
    name: "account-subscription___sv"
  }, {
    path: "/sv/:path",
    component: _7c76b38a,
    name: "path___sv"
  }, {
    path: "/sv/:parent_path/:path?",
    component: _778d938c,
    name: "parent_path-path___sv"
  }, {
    path: "/",
    component: _0547af50,
    name: "index___en"
  }, {
    path: "/:path",
    component: _7c76b38a,
    name: "path___en"
  }, {
    path: "/:parent_path/:path?",
    component: _778d938c,
    name: "parent_path-path___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
